import React from 'react'
import styled from 'styled-components'
import { File, FilePowerpoint } from 'src/icons'
import { FileEarmarkPdf, FileEarmarkWord } from 'src/icons'
import { mapValues } from 'lodash'
import IconPdf from 'url:./assets/icon-pdf.png'
import IconDoc from 'url:./assets/icon-doc.png'
import IconXcl from 'url:./assets/icon-xcl.png'
import IconVid from 'url:./assets/icon-vid.png'
import IconMsg from 'url:./assets/icon-msg.svg'

// todo: add additional icons
export const fileExtMap = {
	pdf: FileEarmarkPdf,
	doc: FileEarmarkWord,
	docx: FileEarmarkWord,
	ppt: FilePowerpoint
}

// Designer file-type icons (NIBBI-113); any other extension keeps the generic icon above
export const designerFileIcons: Record<string, string> = {
	pdf: IconPdf,
	doc: IconDoc,
	docx: IconDoc,
	xls: IconXcl,
	xlsx: IconXcl,
	mp4: IconVid,
	mov: IconVid,
	m4v: IconVid,
	webm: IconVid,
	msg: IconMsg,
	eml: IconMsg
}

export const DesignerFileIcon = styled.img`
	display: block;
	flex-shrink: 0;
	width: 39px;
	height: 41px;
	object-fit: contain;
`

// todo: typing on iconBuilder
export function buildFileIcon(iconBuilder: any, designerIconBuilder: any = (icon) => icon) {
	const defaultIcon = iconBuilder(File)
	const extIcons = mapValues(fileExtMap, (sourceIcon) => iconBuilder(sourceIcon))
	const DesignerIcon = designerIconBuilder(DesignerFileIcon)

	return function ({ ext, ...props }: any) {
		const designerSrc = designerFileIcons[String(ext ?? '').toLowerCase()]
		if (designerSrc) {
			return <DesignerIcon src={designerSrc} alt="" className={props.className} />
		}
		const Icon = extIcons[ext] ?? defaultIcon
		return <Icon {...props}></Icon>
	}
}
